/* PDP clone kit – portrait videos (main section's video row, Video carousel). */
(function () {
  'use strict';
  if (window.__pdpVideo) return;
  window.__pdpVideo = true;
  /* Videos: the round button plays the video and fades out; a click on it again (or on the video) pauses. Only one
     video plays at a time. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-video-play]');
    if (!btn) return;
    var frame = btn.closest('.pdp-vids__frame');
    var video = frame && frame.querySelector('video');
    if (!video) return;
    if (video.paused) {
      document.querySelectorAll('.pdp-vids__frame video').forEach(function (v) { if (v !== video && !v.paused) v.pause(); });
      video.play();
    } else video.pause();
  });
  document.addEventListener('play', function (e) {
    var f = e.target.closest && e.target.closest('.pdp-vids__frame');
    if (f) f.classList.add('is-playing');
  }, true);
  document.addEventListener('pause', function (e) {
    var f = e.target.closest && e.target.closest('.pdp-vids__frame');
    if (f) f.classList.remove('is-playing');
  }, true);
})();
